




































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Search extends Vue {
  // public query!: string;
  public tags: string = "";
  // @Prop() public mode = false;

  public placeholder() {
    if ((this as any).$browserDetect.isChrome) {
      return "Search";
    } else {
      return "";
    }

    // if ((this as any).$globalService.mode) {
    //   return "Search";
    // } else {
    //   return "Search";
    // }
  }

  private search() {
    // (this as any).$globalService.setMode(this.mode);

    if ((this as any).$globalService.mode) {
      this.$router.push(
        "/search?query=tag:" + (this as any).$globalService.query
      );
    } else {
      this.$router.push("/search?query=" + (this as any).$globalService.query);
    }
  }
}
